import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/img/logo.png";

const FlashScreen = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate("/signin"); // Redirect to "/signin" route
        }, 3000); // You can adjust the delay if needed

        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div
            style={{
                background: "linear-gradient(135deg, var(--bg-primary) 0%, var(--primary-purple) 100%)",
                height: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: 0,

            }}
        >
            <div className="logo-container">
                <img
                    src={logo}
                    alt="MReloadpay Logo"
                    style={{ width: "325px", height: "325px" }}
                />

            </div>
        </div>
    );
};

export default FlashScreen;
